export default "__VITE_ASSET__28f4cbe8__"